var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28958 10C3.05792 10 2.82625 9.90385 2.64093 9.71154L0.277992 7.25962C-0.0926641 6.875 -0.0926641 6.29808 0.277992 5.91346C0.648649 5.52885 1.20463 5.52885 1.57529 5.91346L3.28958 7.69231L10.4247 0.288462C10.7954 -0.0961538 11.3514 -0.0961538 11.722 0.288462C12.0927 0.673077 12.0927 1.25 11.722 1.63462L3.93822 9.71154C3.7529 9.90385 3.52124 10 3.28958 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f8e197b25c3b3b5169a533689dd6e490.svg";
export { ForwardRef as ReactComponent };